import React, {useState} from 'react'
import {Box, IconButton, Tooltip} from "@mui/material"
import ContentCopyIcon from "@mui/icons-material/ContentCopy"
import CheckCircleOutlineIcon from "@mui/icons-material/CheckCircleOutline"

function CodeBlock({code}: {code: string}) {
    const [copied, setCopied] = useState(false)

    return (
        <Box sx={{position: "relative", backgroundColor: "#1e1e2e", color: "#e6e6e6", borderRadius: 1, p: 2, overflowX: "auto"}}>
            <Tooltip title={copied ? "Copied" : "Copy"}>
                <IconButton size="small"
                            sx={{position: "absolute", top: 6, right: 6, color: "#aaa"}}
                            onClick={() => navigator.clipboard.writeText(code).then(() => setCopied(true))}>
                    {copied ? <CheckCircleOutlineIcon fontSize="small"/> : <ContentCopyIcon fontSize="small"/>}
                </IconButton>
            </Tooltip>
            <Box component="pre" sx={{m: 0, fontFamily: "monospace", fontSize: 13, whiteSpace: "pre"}}>{code}</Box>
        </Box>
    )
}

export default CodeBlock
